/* Idle state: bands slide down one by one after the pointer is idle; any activity retracts them. */
(() => {
  const root = document.querySelector('[data-idle-stripes]');
  if (!root) return;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduced) return;

  const timeout = Number(root.dataset.idleTimeout || 4) * 1000;
  let timer = null;
  let active = false;

  const fills = root.querySelectorAll('.idle-stripes__fill');
  const motion = () => window.CJR?.motion;

  const show = () => {
    if (active || document.querySelector('dialog[open]')) return;
    active = true;
    root.hidden = false;
    root.classList.add('is-active');
    if (typeof anime !== 'function') { fills.forEach((f) => { f.style.transform = 'translateY(0)'; }); return; }
    anime.remove(fills);
    fills.forEach((f) => { f.style.transform = 'translateY(-100%)'; });
    // open: top band first, each slides down into its slot — the mirror of closing
    anime({
      targets: fills,
      translateY: ['-100%', '0%'],
      easing: 'easeInOutCubic',
      duration: 420,
      delay: anime.stagger(60),
    });
  };

  const hide = () => {
    if (!active) return;
    active = false;
    root.classList.remove('is-active');
    if (typeof anime !== 'function') { fills.forEach((f) => { f.style.transform = ''; }); root.hidden = true; return; }
    anime.remove(fills);
    // close: bottom band first, each slides up out of its slot — the mirror of opening
    anime({
      targets: fills,
      translateY: '-100%',
      easing: 'easeInOutCubic',
      duration: 420,
      delay: anime.stagger(60, { direction: 'reverse' }),
    }).finished.then(() => {
      if (active) return;
      root.hidden = true;
      fills.forEach((f) => { f.style.transform = 'translateY(-100%)'; });
    });
  };

  const arm = () => {
    clearTimeout(timer);
    hide();
    timer = setTimeout(show, timeout);
  };

  ['mousemove', 'mousedown', 'keydown', 'wheel', 'scroll', 'touchstart'].forEach((evt) =>
    window.addEventListener(evt, arm, { passive: true, capture: evt === 'scroll' })
  );
  document.addEventListener('visibilitychange', () => (document.hidden ? clearTimeout(timer) : arm()));
  arm();
})();
